module.exports = __webpack_public_path__ + "static/green_dragon_seek-6a4ad46f58cbe550de70fb66c880e4a8.jpg";